
  import { Vue, Component } from "vue-property-decorator";

  @Component({})
  export default class PaymentCardForm extends Vue {
    elementClasses = {
      focus: "focus",
      invalid: "invalid",
    };

    get stripeLoaded(): boolean {
      return this.$stripe !== undefined;
    }

    mounted(): void {
      const elements = this.$stripe.elements();
      const card = elements.create("card", {
        style: {
          base: {
            fontSize: "1.5rem",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#d0d3d9",
              fontSize: "1rem",
            },
          },
        },
        classes: this.elementClasses,
      });

      card.mount(this.$refs.card);
      card.on("change", (event) => {
        if (!event) {
          return;
        }

        const complete = event.complete;

        this.$emit("change", { complete, card });
      });
    }
  }
